function Container({ children }) {
  return (
    <div className="app-root">
      {children}
    </div>
  )
}

export { Container }
